 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTMAP from '@/components/Text/map'
 import TEXTDEDT from '@/components/Text/dedt'
 import TEXTINTRO from '@/components/Text/intro'
 import TEXTPART1 from '@/components/Text/part1'
 import TEXTCHAP1 from '@/components/Text/chap1'
 import TEXTCHAP2 from '@/components/Text/chap2'
 import TEXTCHAP3 from '@/components/Text/chap3'
 import TEXTPART2 from '@/components/Text/part2'
 import TEXTCHAP4 from '@/components/Text/chap4'
 import TEXTCHAP5 from '@/components/Text/chap5'
 import TEXTCHAP6 from '@/components/Text/chap6'
 import TEXTCHAP7 from '@/components/Text/chap7'
 import TEXTPART3 from '@/components/Text/part3'
 import TEXTCHAP8 from '@/components/Text/chap8'
 import TEXTCHAP9 from '@/components/Text/chap9'
 import TEXTCHAP10 from '@/components/Text/chap10'
 import TEXTCHAP11 from '@/components/Text/chap11'
 import TEXTPART4 from '@/components/Text/part4'
 import TEXTCHAP12 from '@/components/Text/chap12'
 import TEXTCHAP13 from '@/components/Text/chap13'
 import TEXTCHAP14 from '@/components/Text/chap14'
 import TEXTCHAP15 from '@/components/Text/chap15'
 import LOVE_2 from '@/components/love_2'
 import TEXTGLOSSARY from '@/components/Text/glossary'
 import TEXTBIO from '@/components/Text/bio'
 import TEXTEXTRA from '@/components/Text/extra'
 import TEXTTWILIGHT from '@/components/Text/twilight'
 import TEXTNOIR from '@/components/Text/noir'
 import TEXTAWARD from '@/components/Text/award'
 import TEXTAKB from '@/components/Text/akb'
 import TEXTCOPY from '@/components/Text/copy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/map",
 			"name" : "Text/map",
 			"component" : TEXTMAP
 		},
 		{
 			"path" : "/Text/dedt",
 			"name" : "Text/dedt",
 			"component" : TEXTDEDT
 		},
 		{
 			"path" : "/Text/intro",
 			"name" : "Text/intro",
 			"component" : TEXTINTRO
 		},
 		{
 			"path" : "/Text/part1",
 			"name" : "Text/part1",
 			"component" : TEXTPART1
 		},
 		{
 			"path" : "/Text/chap1",
 			"name" : "Text/chap1",
 			"component" : TEXTCHAP1
 		},
 		{
 			"path" : "/Text/chap2",
 			"name" : "Text/chap2",
 			"component" : TEXTCHAP2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js